import styled from 'styled-components';
import { CustomLabelInput } from '../../../../../components/input/CustomLabelInput';
import { useEffect, useState } from 'react';
import CustomBlockButton from '../../../../../components/button/CustomBlockButton';
import { CustomDialog } from '../../../../../components/dialog/v1/CustomDialog';
import { useApiInfoContextValueHook } from '../../../../../contexts/ApiInfoContext';
import { SellertoolSignatureUtils } from '../../../../../utils/sellertool-signature-utils';
import { CommerceApiApi } from '../../../../../apis/CommerceApiApi';
import { CoupangApiApi } from '../../../../../apis/CoupangApiApi';
import { CustomBackdropController } from '../../../../../components/backdrop/default/v1';
import { ReturnExchangesApi } from '../../../../../apis/ReturnExchangesApi';
import { customToast } from '../../../../../components/toast/custom-react-toastify/v1';

const StyledContainer = styled.div`
    padding: 10px;
    
    .form-fields{
        display: flex;
        flex-direction: column;
        gap: 20px;
        /* max-width: 500px; */
        margin-left: auto;
        margin-right: auto;
        height: 400px;
        overflow: auto;
        border: 1px solid #e0e0e0;
        border-radius: 3px;
        padding: 10px;
    }

    .failure-reason{
        margin-top: 20px;
        .label{
            margin-top: 5px;
            font-size: 12px;
            font-weight: 600;
            color: var(--redColor1);
        }
    }

    .register-button{
        margin-top: 20px;
        button{
            border-radius: 3px;
            background-color: #333;
            color:#fff;
            border:none;
            font-weight: 700;
        }
    }
`;

const StyledBox = styled.div`
    max-width: 500px;
    input{
        background-color: #fff;
        border-radius: 3px;
        border-color: #e0e0e0;
    }

    .label{
        font-size: 12px;
        color: #333;
        font-weight: 600;
        margin-bottom: 5px;
    }

    button{
        background-color: #333;
        color: #fff;
        font-weight: 600;
        border-radius: 3px;
        border:none;
    }
`;

const StyledModalHeader = styled.div`
    padding: 10px;
`;

const StyledModalBody = styled.div`
    padding: 10px;

    .flexible{
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    button{
        background-color: #fff;
        color: #333;
        font-weight: 600;
        border-radius: 3px;
        border: 1px solid #e0e0e0;
    }
`;

const INITIAL_FORM_DATA = {
    orderNumber1: '',
    returnExchangeType: 'RETURN',
    returnExchangeProceedStatus: 'PREPARING',
    returnExchangeQuantity: '',
    returnExchangeDeliveryPaidMethod: '',
    customerRequestCollectionMethod: '',
    collectionWaybillNumber: '',
    collectionOptionCode: '',
    inspectionResultMemo: '',
    inspectionPassedQuantity: '',
    salesChannelMatchingStoreId: '',
    salesChannelMatchingStoreMemo: '',
    systemClaim: '',
    customerClaim: '',
    returnExchangeMemo1: '',
    returnExchangeMemo2: '',
}

export function WegetFormField(props) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const [storeInfos, setStoreInfos] = useState([]);

    useEffect(() => {
        if (!apiInfoContextValueHook?.apiInfo?.apiKey || !apiInfoContextValueHook?.apiInfo?.secretKey) {
            return;
        }

        handleFetchStoreInfos();
    }, [
        apiInfoContextValueHook?.apiInfo?.apiKey,
        apiInfoContextValueHook?.apiInfo?.secretKey,
    ])

    const [formData, setFormData] = useState(INITIAL_FORM_DATA);

    const [returnExchangeTypeModalOpen, setReturnExchangeTypeModalOpen] = useState(false);
    const [returnExchangeProceedStatusModalOpen, setReturnExchangeProceedStatusModalOpen] = useState(false);
    const [salesChannelMatchingStoreIdModalOpen, setSalesChannelMatchingStoreIdModalOpen] = useState(false);

    const [failureContents, setFailureContents] = useState([]);

    const handleFetchStoreInfos = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        let storeInfos = [];

        const commerceApiStoreInfosResponse = await CommerceApiApi().searchCommerceApiStoreInfos({
            headers: headers
        })
        const coupangApiStoreInfosResponse = await CoupangApiApi().searchCoupangApiStoreInfos({
            headers: headers
        })

        if (commerceApiStoreInfosResponse?.content) {
            commerceApiStoreInfosResponse?.content?.forEach(storeInfo => {
                storeInfos.push({
                    id: storeInfo.id,
                    storeName: storeInfo.storeName,
                    storeType: 'COMMERCE_API'
                })
            })
        }

        if (coupangApiStoreInfosResponse?.content) {
            coupangApiStoreInfosResponse?.content?.forEach(storeInfo => {
                storeInfos.push({
                    id: storeInfo.id,
                    storeName: storeInfo.storeName,
                    storeType: 'COUPANG_API'
                })
            })
        }

        setStoreInfos(storeInfos);
    }

    const handleSubmit = async () => {
        setFailureContents(null);
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const body = {
            formDatas: [
                { ...formData }
            ]
        }
        CustomBackdropController().showBackdrop();
        const response = await ReturnExchangesApi().createListFromSystem({
            headers: headers,
            body: body
        });

        if (response?.content?.successContents && response?.content?.successContents?.length > 0) {
            customToast.success('등록되었습니다.');
            setFormData(INITIAL_FORM_DATA);
        } else {
            setFailureContents(response?.content?.failureContents);
        }
        CustomBackdropController().hideBackdrop();
    }

    return (
        <>
            <StyledContainer>
                <div className='form-fields'>
                    <StyledBox>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='text'
                                value={formData?.orderNumber1 || ''}
                                onChange={(e) => setFormData({ ...formData, orderNumber1: e.target.value })}
                            />
                            <CustomLabelInput.Label>주문번호1 <span style={{ color: 'var(--redColor1)' }}>*</span></CustomLabelInput.Label>
                        </CustomLabelInput>
                    </StyledBox>
                    <StyledBox>
                        <div className='label'>반품/교환 타입 <span style={{ color: 'var(--redColor1)' }}>*</span></div>
                        <CustomBlockButton
                            type='button'
                            onClick={() => setReturnExchangeTypeModalOpen(true)}
                        >
                            {ReturnExchangeTypes.find(type => type.value === formData?.returnExchangeType)?.label || '선택'}
                        </CustomBlockButton>
                    </StyledBox>
                    <StyledBox>
                        <div className='label'>진행상태 <span style={{ color: 'var(--redColor1)' }}>*</span></div>
                        <CustomBlockButton
                            type='button'
                            onClick={() => setReturnExchangeProceedStatusModalOpen(true)}
                        >
                            {ReturnExchangeProceedStatuses.find(type => type.value === formData?.returnExchangeProceedStatus)?.label || '선택'}
                        </CustomBlockButton>
                    </StyledBox>
                    <StyledBox>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='number'
                                value={formData?.returnExchangeQuantity || ''}
                                onChange={(e) => setFormData({ ...formData, returnExchangeQuantity: e.target.value })}
                            />
                            <CustomLabelInput.Label>회수수량 <span style={{ color: 'var(--redColor1)' }}>*</span></CustomLabelInput.Label>
                        </CustomLabelInput>
                    </StyledBox>
                    <StyledBox>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='text'
                                value={formData?.returnExchangeDeliveryPaidMethod || ''}
                                onChange={(e) => setFormData({ ...formData, returnExchangeDeliveryPaidMethod: e.target.value })}
                            />
                            <CustomLabelInput.Label>배송비지불방식</CustomLabelInput.Label>
                        </CustomLabelInput>
                    </StyledBox>
                    <StyledBox>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='text'
                                value={formData?.customerRequestCollectionMethod || ''}
                                onChange={(e) => setFormData({ ...formData, customerRequestCollectionMethod: e.target.value })}
                            />
                            <CustomLabelInput.Label>고객요청수거방식</CustomLabelInput.Label>
                        </CustomLabelInput>
                    </StyledBox>
                    <StyledBox>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='text'
                                value={formData?.collectionWaybillNumber || ''}
                                onChange={(e) => setFormData({ ...formData, collectionWaybillNumber: e.target.value })}
                            />
                            <CustomLabelInput.Label>회수운송장번호</CustomLabelInput.Label>
                        </CustomLabelInput>
                    </StyledBox>
                    <StyledBox>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='text'
                                value={formData?.collectionOptionCode || ''}
                                onChange={(e) => setFormData({ ...formData, collectionOptionCode: e.target.value })}
                            />
                            <CustomLabelInput.Label>회수상품옵션코드</CustomLabelInput.Label>
                        </CustomLabelInput>
                    </StyledBox>
                    <StyledBox>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='text'
                                value={formData?.inspectionResultMemo || ''}
                                onChange={(e) => setFormData({ ...formData, inspectionResultMemo: e.target.value })}
                            />
                            <CustomLabelInput.Label>검수결과</CustomLabelInput.Label>
                        </CustomLabelInput>
                    </StyledBox>
                    <StyledBox>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='number'
                                value={formData?.inspectionPassedQuantity || ''}
                                onChange={(e) => setFormData({ ...formData, inspectionPassedQuantity: e.target.value })}
                            />
                            <CustomLabelInput.Label>정상제품수량</CustomLabelInput.Label>
                        </CustomLabelInput>
                    </StyledBox>
                    <StyledBox>
                        <div className='label'>매칭판매채널ID</div>
                        <CustomBlockButton
                            type='button'
                            onClick={() => setSalesChannelMatchingStoreIdModalOpen(true)}
                        >
                            {formData?.salesChannelMatchingStoreId ?
                                <>
                                    {formData?.salesChannelMatchingStoreId} ({storeInfos.find(storeInfo => storeInfo.id === formData?.salesChannelMatchingStoreId)?.storeName || '선택'})
                                </>
                                :
                                <>선택</>
                            }
                        </CustomBlockButton>
                    </StyledBox>
                    <StyledBox>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='text'
                                value={formData?.salesChannelMatchingStoreMemo || ''}
                                onChange={(e) => setFormData({ ...formData, salesChannelMatchingStoreMemo: e.target.value })}
                            />
                            <CustomLabelInput.Label>매칭판매채널메모</CustomLabelInput.Label>
                        </CustomLabelInput>
                    </StyledBox>
                    <StyledBox>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='text'
                                value={formData?.systemClaim || ''}
                                onChange={(e) => setFormData({ ...formData, systemClaim: e.target.value })}
                            />
                            <CustomLabelInput.Label>시스템 클레임</CustomLabelInput.Label>
                        </CustomLabelInput>
                    </StyledBox>
                    <StyledBox>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='text'
                                value={formData?.customerClaim || ''}
                                onChange={(e) => setFormData({ ...formData, customerClaim: e.target.value })}
                            />
                            <CustomLabelInput.Label>고객 클레임</CustomLabelInput.Label>
                        </CustomLabelInput>
                    </StyledBox>
                    <StyledBox>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='text'
                                value={formData?.returnExchangeMemo1 || ''}
                                onChange={(e) => setFormData({ ...formData, returnExchangeMemo1: e.target.value })}
                            />
                            <CustomLabelInput.Label>메모1</CustomLabelInput.Label>
                        </CustomLabelInput>
                    </StyledBox>
                    <StyledBox>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='text'
                                value={formData?.returnExchangeMemo2 || ''}
                                onChange={(e) => setFormData({ ...formData, returnExchangeMemo2: e.target.value })}
                            />
                            <CustomLabelInput.Label>메모2</CustomLabelInput.Label>
                        </CustomLabelInput>
                    </StyledBox>
                </div>
                {failureContents?.length > 0 && (
                    <div className='failure-reason'>
                        <div className='label'>등록실패</div>
                        <div>
                            {failureContents?.map((failureContent, index) => (
                                <div key={index}>
                                    <div className='label'>주문번호1 : {failureContent.orderNumber1}</div>
                                    <div className='label'>{failureContent.reason}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                <div className='register-button'>
                    <CustomBlockButton
                        type='button'
                        className='register-button'
                        onClick={() => handleSubmit()}
                    >
                        등록
                    </CustomBlockButton>
                </div>
            </StyledContainer>

            {returnExchangeTypeModalOpen && (
                <ReturnExchangeTypeModal
                    open={returnExchangeTypeModalOpen}
                    onClose={() => setReturnExchangeTypeModalOpen(false)}
                    onConfirm={(type) => {
                        setFormData({ ...formData, returnExchangeType: type });
                        setReturnExchangeTypeModalOpen(false);
                    }}
                />
            )}

            {returnExchangeProceedStatusModalOpen && (
                <ReturnExchangeProceedStatusModal
                    open={returnExchangeProceedStatusModalOpen}
                    onClose={() => setReturnExchangeProceedStatusModalOpen(false)}
                    onConfirm={(status) => {
                        setFormData({ ...formData, returnExchangeProceedStatus: status });
                        setReturnExchangeProceedStatusModalOpen(false);
                    }}
                />
            )}

            {salesChannelMatchingStoreIdModalOpen && (
                <SalesChannelMatchingStoreIdModal
                    open={salesChannelMatchingStoreIdModalOpen}
                    onClose={() => setSalesChannelMatchingStoreIdModalOpen(false)}
                    storeInfos={storeInfos}
                    onConfirm={(storeId) => {
                        setFormData({ ...formData, salesChannelMatchingStoreId: storeId });
                        setSalesChannelMatchingStoreIdModalOpen(false);
                    }}
                />
            )}
        </>
    );
}

function ReturnExchangeTypeModal({
    open,
    onClose,
    onConfirm
}) {
    return (
        <>
            <CustomDialog
                open={open}
                onClose={onClose}
            >
                <StyledModalHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>반품/교환 타입 선택</CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={onClose} />
                    </CustomDialog.Header>
                </StyledModalHeader>
                <StyledModalBody>
                    <div className='flexible'>
                        {ReturnExchangeTypes.map((type, index) => (
                            <CustomBlockButton
                                key={index}
                                type='button'
                                onClick={() => onConfirm(type.value)}
                            >
                                {type.label}
                            </CustomBlockButton>
                        ))}
                    </div>
                </StyledModalBody>
            </CustomDialog>
        </>
    );
}

function ReturnExchangeProceedStatusModal({
    open,
    onClose,
    onConfirm
}) {
    return (
        <>
            <CustomDialog
                open={open}
                onClose={onClose}
            >
                <StyledModalHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>진행상태 선택</CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={onClose} />
                    </CustomDialog.Header>
                </StyledModalHeader>
                <StyledModalBody>
                    <div className='flexible'>
                        {ReturnExchangeProceedStatuses.map((type, index) => (
                            <CustomBlockButton
                                key={index}
                                type='button'
                                onClick={() => onConfirm(type.value)}
                            >
                                {type.label}
                            </CustomBlockButton>
                        ))}
                    </div>
                </StyledModalBody>
            </CustomDialog>
        </>
    );
}

function SalesChannelMatchingStoreIdModal({
    open,
    onClose,
    storeInfos,
    onConfirm
}) {
    return (
        <>
            <CustomDialog
                open={open}
                onClose={onClose}
            >
                <StyledModalHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>매칭판매채널ID 선택</CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={onClose} />
                    </CustomDialog.Header>
                </StyledModalHeader>
                <StyledModalBody>
                    <div className='flexible'>
                        {storeInfos.map((storeInfo, index) => (
                            <CustomBlockButton
                                key={index}
                                type='button'
                                onClick={() => onConfirm(storeInfo.id)}
                            >
                                {storeInfo.storeName}
                            </CustomBlockButton>
                        ))}
                    </div>
                </StyledModalBody>
            </CustomDialog>
        </>
    );
}

const ReturnExchangeTypes = [
    {
        label: '교환',
        value: 'EXCHANGE'
    },
    {
        label: '반품',
        value: 'RETURN'
    }
]

const ReturnExchangeProceedStatuses = [
    {
        label: '준비중',
        value: 'PREPARING'
    },
    {
        label: '수거요청',
        value: 'COLLECTION_REQUEST'
    },
    {
        label: '수거중',
        value: 'COLLECTING'
    },
    {
        label: '수거완료',
        value: 'COLLECTION_COMPLETE'
    },
    {
        label: '검수완료',
        value: 'INSPECTION_COMPLETE'
    },
    {
        label: '처리완료',
        value: 'PROCESSING_COMPLETE'
    },
    {
        label: '반송',
        value: 'RETURN_SHIPMENT'
    },
    {
        label: '교환재배송준비',
        value: 'EXCHANGE_RE_SHIPMENT_PREPARATION'
    },
    {
        label: '교환재배송중',
        value: 'EXCHANGE_RE_SHIPMENT_COMPLETE'
    }
]